<template>
  <svg
    width="176"
    height="201"
    viewBox="0 0 176 201"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="1">
      <path
        id="vShape"
        d="M138.614 194.839H37.386L81.4809 47.8426C81.9033 46.4423 82.7654 45.2153 83.9395 44.3431C85.1136 43.4709 86.5373 43 87.9999 43C89.4626 43 90.8863 43.4709 92.0604 44.3431C93.2345 45.2153 94.0966 46.4423 94.519 47.8426L138.614 194.839Z"
        stroke="white"
        :style="vShape"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="lines"
        d="M67.7544 93.6143H108.246"
        stroke="white"
        stroke-width="10"
        stroke-linecap="round"
        :style="lines"
        stroke-linejoin="round"
      />
      <path
        id="lines"
        d="M61.6804 113.859H114.319"
        stroke="white"
        stroke-width="10"
        stroke-linecap="round"
        :style="lines"
        stroke-linejoin="round"
      />
      <path
        id="lines"
        d="M52.5701 144.228H123.43"
        stroke="white"
        stroke-width="10"
        stroke-linecap="round"
        :style="lines"
        stroke-linejoin="round"
      />
      <path
        id="lines"
        d="M46.4963 164.473H129.503"
        stroke="white"
        stroke-width="10"
        stroke-linecap="round"
        :style="lines"
        stroke-linejoin="round"
      />
      <path
        id="baseLine"
        d="M22.2017 194.842H153.798"
        stroke="white"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        :style="baseLine"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Vue } from "vue-facing-decorator";
import { Component } from "vue-facing-decorator";

@Component({})
export default class Cone extends Vue {
  public strokeVShape = 0;
  public strokeBaseLine = 0;
  public strokeLines = 0;

  mounted() {
    this.strokeVShape = (
      document.getElementById("vShape") as any
    ).getTotalLength();
    this.strokeBaseLine = (
      document.getElementById("vShape") as any
    ).getTotalLength();
    this.strokeLines = (
      document.getElementById("vShape") as any
    ).getTotalLength();
  }

  get vShape() {
    return {
      "stroke-dasharray": this.strokeVShape,
      "stroke-dashoffset": this.strokeVShape,
    };
  }
  get baseLine() {
    return {
      "stroke-dasharray": this.strokeBaseLine,
      "stroke-dashoffset": this.strokeBaseLine,
    };
  }
  get lines() {
    return {
      "stroke-dasharray": this.strokeLines,
      "stroke-dashoffset": this.strokeLines,
    };
  }
}
</script>

<style scoped>
#vShape {
  animation: line-animation 2s ease forwards 0.3s;
}

#baseLine {
  animation: line-animation 2s ease forwards;
}

#lines {
  animation: line-animation 2s ease forwards 2s;
}

@keyframes line-animation {
  to {
    stroke-dashoffset: 0;
  }
}
</style>
